
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'kon-divider-type',
    imports: [],
    template: ` <div class="h-px w-full bg-gray-200 mb-1"></div> `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormlyDividerTypeComponent extends FieldType {}
